"use client";
import * as s from "react";
import { N as a } from "./noop-CMWc2wUO.mjs";
let l = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const i = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, o = {
  valid(e) {
    return e === null ? null : e ? {
      [l.valid]: ""
    } : {
      [l.invalid]: ""
    };
  }
}, t = /* @__PURE__ */ s.createContext({
  invalid: void 0,
  controlId: void 0,
  setControlId: a,
  labelId: void 0,
  setLabelId: a,
  messageIds: [],
  setMessageIds: a,
  name: void 0,
  validityData: {
    state: i,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: a,
  disabled: void 0,
  touched: !1,
  setTouched: a,
  dirty: !1,
  setDirty: a,
  filled: !1,
  setFilled: a,
  focused: !1,
  setFocused: a,
  validate: () => null,
  validationMode: "onBlur",
  validationDebounceTime: 0,
  state: {
    disabled: !1,
    valid: null,
    touched: !1,
    dirty: !1,
    filled: !1,
    focused: !1
  },
  markedDirtyRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (t.displayName = "FieldRootContext");
function f(e = !0) {
  const d = s.useContext(t);
  if (d.setControlId === a && !e)
    throw new Error("Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>.");
  return d;
}
export {
  i as D,
  t as F,
  o as f,
  f as u
};
